import { forwardRef } from 'react';

import type { IconProps } from './types';

const Replay10 = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', ...props }, forwardedRef) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 1024 1024"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={forwardedRef}
  >
    <path
      d="M464 0C330.907 0 206.006 51.107 112 140.188V64c0-17.673-14.327-32-32-32S48 46.327 48 64v160c0 8.837 3.584 16.834 9.375 22.625S71.163 256 80 256h160c17.673 0 32-14.327 32-32s-14.327-32-32-32h-89.562C233.319 110.725 344.865 64 464 64c247.424 0 448 200.576 448 448S711.424 960 464 960c-129.341 0-249.747-55.086-334.25-149.687-11.773-13.18-32.007-14.336-45.188-2.562s-14.273 32.007-2.5 45.187C178.583 960.994 316.238 1024 464 1024c282.77 0 512-229.23 512-512S746.77 0 464 0zm120.875 407.938c-27.083 0-47.104 9.646-60.125 28.813-13.021 19.062-19.563 48.687-19.563 89 0 38.646 6.667 67.896 20 87.687 13.438 19.792 33.333 29.687 59.688 29.687 27.187 0 47.292-9.583 60.312-28.75 13.125-19.167 19.688-48.729 19.688-88.625 0-38.542-6.771-67.813-20.313-87.813-13.438-20-33.333-30-59.687-30zm-181.25 3.624L330 470.187l23.312 29.062 26.25-21.125c3.125-2.5 8.667-7.792 16.687-15.812l-.75 23.812-.438 21.688v132.187h48.25V411.561h-39.688zm181.25 35.5c11.146 0 19.25 6.083 24.25 18.375 5.104 12.188 7.625 32.292 7.625 60.313 0 27.708-2.5 47.708-7.5 60s-13.125 18.5-24.375 18.5c-11.458 0-19.667-6.042-24.562-18.125-4.792-12.187-7.125-32.354-7.125-60.375s2.417-48.125 7.313-60.313c4.896-12.292 13.021-18.375 24.375-18.375zm-367.313 87.625v39.063h83.875v-39.063h-83.875z"
      fill={color}
    />
  </svg>
));

export default Replay10;
